<template>
  <div class="main-wrapper">
    <div id="mobChat" style="overflow: scroll;overflow-x:hidden; height: 100%" class="container-fluid">
      <div id="mobchatid" class="panel-body1 panel-body-web" style="position: fixed; top: 0; left: 0; width: 100%;">
        <div id="paddingDiv"></div>
        <div id="panelChat" class="panel">
          <ul v-if = "!isRtaWebChatBot" id="chatMessages" class="chat s-container">
            <li class="left clearfix custom-background">
              <div class="left">
                <h5>
                    <span class="status1">
                        <span class="status"><span
                            class=statusupdate>{{ labels['chatbox.CHAT_STATUS_UPDATE_TEXT'] }}</span>
                            <span>&nbsp;{{ }}&nbsp;{{ }}&nbsp;</span>
                            <span class="" id="agentWaiting" style="color:#FFC200"> <i
                                class="fa fa-circle"></i><span>&nbsp;{{ }}&nbsp;{{ }}&nbsp;</span>{{
                                labels['chatbox.CHAT_STATUS_WAITING_TEXT']
                              }}</span>
                            <span class="" id="agentConnected"
                                  style="display: none; color:green"> <i
                                class="fa fa-circle"></i><span>&nbsp;{{ }}&nbsp;{{ }}&nbsp;</span>{{
                                labels['chatbox.CHAT_STATUS_CONNECTED_TEXT']
                              }}</span>
                            <span class="" id="agentDisconnected" style="display: none; color:red"> <i
                                class="fa fa-circle"></i><span>&nbsp;{{ }}&nbsp;{{ }}&nbsp;</span>{{
                                labels['chatbox.CHAT_STATUS_NOT_CONNECTED_TEXT']
                              }}</span>
                        </span>
                    </span>
                </h5>
              </div>
              <div class="chat-date-close">
                <div class="right date-s">
                  <div v-if="lang=='ar'">
                    <span class="t-grey-txt datestyle" style="color: #00080A;">{{ labels['chatbox.TODAY_TEXT'] }}</span>
                    <span id="chatDateDetails" class="datemsg datestyle"
                          style="color: #00080A;font-weight: bold;"><span>{{ chatDateDay }}</span><span
                        class="datestyle">{{ chatDateMonth }}&nbsp;</span><span>{{ chatDateYear }}</span></span>
                  </div>
                  <div v-if="lang=='en'">
                    <span class="t-grey-txt" style="color: #00080A;">{{ labels['chatbox.TODAY_TEXT'] }}</span>
                    <span id="chatDateDetails" class="datemsg datestyle"
                          style="color: #00080A;font-weight: bold;"><span>{{ chatDateDay }}</span><span
                        class="datestyle">{{ chatDateMonth }}&nbsp;</span><span>{{ chatDateYear }}</span></span>
                  </div>
                </div>
                <div class="close-option" v-on:click="openFeedback()">
                  <img src="../assets/images/cross-button.png" width="21px">
                  <div id="chatFeedback" style="display:none">
                    <feedBack/>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <ul v-if = "isRtaWebChatBot" id="chatMessages" class="chat s-container">
            <li class="left clearfix custom-background">
              <a id="crosswhite" class="button-on-x"  v-on:click="openFeedback();">
                &times; </a>
              <div id="chatFeedback" style="display:none">
                <feedBack/>
              </div>
              <div class="left">
                <h5>
                  <span class="">
                      <span class="status">
                          <p class="webChatBotHeader" style="margin-left: 120px;">
                              <span>&nbsp;{{ }}&nbsp;{{ }}&nbsp;</span>
                              <span class="" id="agentWaiting" style="color:#FFC200"> <i
                                  class="fa fa-circle"></i><span>&nbsp;{{ }}&nbsp;{{ }}&nbsp;</span>{{
                                  labels['chatbox.CHAT_STATUS_WAITING_TEXT']
                                }}</span>
                              <span class="" id="agentConnected"
                                    style="display: none; color:green"> <i
                                  class="fa fa-circle"></i><span>&nbsp;{{ }}&nbsp;{{ }}&nbsp;</span>{{
                                  labels['chatbox.CHAT_STATUS_CONNECTED_TEXT']
                                }}</span>
                              <span class="" id="agentDisconnected" style="display: none; color:red"> <i
                                  class="fa fa-circle"></i><span>&nbsp;{{ }}&nbsp;{{ }}&nbsp;</span>{{
                                  labels['chatbox.CHAT_STATUS_NOT_CONNECTED_TEXT']
                                }}</span>
                          </p>
                        <div v-if="lang=='ar'">
                        <p class="webChatBotHeader">
                          <span class="t-grey-txt datestyle" style="color: #00080A;">{{ labels['chatbox.TODAY_TEXT'] }}</span>
                          <span id="chatDateDetails" class="datemsg datestyle"
                                style="color: #00080A;font-weight: bold;"><span>{{ chatDateDay }}</span><span
                              class="datestyle">{{ chatDateMonth }}&nbsp;</span><span>{{ chatDateYear }}</span></span></p>
                        </div>

                        <div v-if="lang=='en'">
                            <p class="webChatBotHeader">
                              <span class="t-grey-txt" style="color: #00080A;">{{ labels['chatbox.TODAY_TEXT'] }}</span>
                              <span id="chatDateDetails" class="datemsg datestyle" style="color: #00080A;font-weight: bold;">
                                <span>{{ chatDateDay }}</span>
                                <span class="datestyle">{{ chatDateMonth }}&nbsp;</span><span>{{ chatDateYear }}</span>
                              </span>
                            </p>
                        </div>
                      </span>
                  </span>
                </h5>
              </div>
            </li>
          </ul>

          <div id="chatcontentcontainer" class="panel-body chat-panel-margin">
            <ul v-if="!messageList || !messageList.length" class="chat" id="waitForAgentMsg">
              <li class="agent">
                <em>CC</em>
                <div class="left-curve">
                  <div class="square-left" style="background: grey"></div>
                  <div class="triangle-left" style="background: #e1e1e1"></div>
                </div>
                <h2 class="ccMsg">{{ labels['chatbox.CONTAC_CENTER'] }}</h2>
                <div class="chat-text"><p>{{ labels['chatbox.CONTAC_CENTER_MSG'] }}</p></div>
              </li>
            </ul>
            <ul id="history" class="chat">
              <div id="messageDiv" v-for="message in messageList" :key="message.id">
                <li v-if="message.type =='customer'" class="user" id="userli">
                  <span class="time" id="usertime">{{ message.messageTime }}</span>
                  <div style="clear:both"></div>
                  <em :style="{'border-color': appColorCode, 'color': appColorCode}">{{ message.senderShotName }}</em>
                  <div class="right-curve">
                    <div class="square-right" :style="{'background-color': appColorCode}"></div>
                    <div class="triangle-right" style="background: lightblue"></div>
                  </div>
                  <h2 :style="{'background-color': appColorCode}" >{{ message.sender }}</h2>
                  <div class="chat-text">
                    <p v-if="lang=='ar'" align="right" style="text-align: right" id="cutomerChatMessage" dir="rtl">{{ message.messageText }}</p>
                    <p v-else id="cutomerChatMessage" dir="ltr">{{ message.messageText }}</p>
                  </div>
                </li>
                <li v-if="message.type =='agent'" class="agent">
                  <span class="time" id="agenttime">{{ message.messageTime }}</span>
                  <div style="clear:both"></div>
                  <em>{{ message.senderShotName }}</em>
                  <div class="left-curve">
                    <div class="square-left" style="background: grey"></div>
                    <div class="triangle-left" style="background: #e1e1e1"></div>
                  </div>
                  <h2>{{ message.sender }}</h2>
                  <div class="chat-text">
                    <div v-html="getAgentMessage(message.messageText)" @click="setDubaiDriveURL" ></div>
                  </div>
                </li>
                <li v-if="message.type == 'agentDisconnected'">
                  <div id="agentDisconnected" class="chat-text" style="display: none;">
                    <p style="margin-top:11%;">{{ message.messageText }}</p>
                  </div>
                </li>
              </div>
            </ul>
            <ul v-if="sessionEnd" class="chat" id="waitForAgentMsg">
              <li class="agent">
                <h2 class="ccMsg">{{ labels['chatbox.CONTAC_CENTER'] }}</h2>
                <div class="chat-text"><p>{{ labels['chatbox.Session_End_Text'] }}</p></div>
              </li>
            </ul>
          </div>
          <br><br/>
          <br><br/>
        </div>
      </div>
    </div>
    <div id="cont_close" title="this.labels['chatbox.CONTINUE_CLOSE']"></div>
    <div id="attach_close" title="this.labels['chatbox.CONTINUE_CLOSE_ATTACH']"></div>
    <div id="cont-close-dubai" class="ddDialogClass" style="display: none" title="this.labels['chatbox.CONTINUE_CLOSE_DUBAI_TITLE']" > <img  id="alert-image" class="alert-image" src="../assets/images/tip.svg"></div>
    <div class="panel-footer" id="chatTextArea" :style="[isRtaWebChatBot ? {position: 'fixed', 'background-color': '#53565a !important'} : {position: 'fixed'}]">
      <h6 class="agent-type-data">
        <span id="AgentStatus" class=stmsg></span>
      </h6>
      <span v-if="attachmentIsActive" class="file-attached">	 </span>
      <div class="input-group dirltr">
			<textarea name="comments" id="comments" rows="1"
                class="form-control input-sm txtar hideXYscroll" maxlength="1000" :blur="restoreHeight()"
                :focus="adjustHeight()" :click="scrollUp()" :keydown="onType"
                style="overflow-y: auto;min-height: 40px; max-height: 110px;line-height:1.3;"
                :placeholder="this.labels['chatbox.CHAT_ENTER_QUESTION_HERE_TEXT']"></textarea>
        <label v-if="attachmentIsActive" for="fileinput" class="">
          <img class="attach" :src="isRtaWebChatBot ? require('../assets/img/paper-clip-icon.png') : require('../assets/images/paper-clip1.png')" :style="[isRtaWebChatBot ? {'width': '28px', 'margin-top': '-70px'} : {}]">
        </label>
        <input v-if="attachmentIsActive" type="file" style="visibility:hidden;" id="fileinput" ref="file"
               accept=".pdf,.gif,.jpeg,.jpg,.png,.bmp" @change="attachContinueClose()">
        <input v-if="attachmentIsActive" type="file" >
        <div v-if="!attachmentIsActive" style="height: 100px;"></div>
        <span class="input-group-btn">
                <button class="btn btn-sm " :style="[isRtaWebChatBot ? (lang =='ar' ? {'color':'white', 'margin-top':'-225px !important', 'border-radius':'0 !important'} : {'color':'white', 'margin-top':'-95px !important', 'border-radius':'0 !important'}) : (lang =='en' ? {'color':'white', 'margin-top':'-8rem'} : {})]" id="sendMessageButton"
                        v-on:click="sendChatMessage()">{{ labels['chatbox.BTNSEND'] }}</button>
            </span>
      </div>
      <span style="color:grey" id="filename"></span>
    </div>
  </div>
</template>

<script>
import WebChat from '../assets/js/chat/webChat'
import WebChatUI from '../assets/js/chat/webChatUI'

import Feedback from './Feedback';
import $ from 'jquery'
import http from "../http-common"
import Vue from 'vue'
import {v4 as uuidv4} from "uuid";
import axios from "axios";

export default {
  name: "Chat",
  components: {
    feedBack: Feedback,
  },
  data() {
    return {
      lang: this.$route.query.lang,
      chatDateDay: '',
      chatDateMonth: '',
      chatDateYear: '',
      customerMessageList: [],
      messageList: WebChat.messageList,
      customerFeedback: WebChat.customerFeedback,
      file: null,
      fileUploadURL: "",
      labels: Vue.prototype.$labels,
      sessionEnd: false,
      isRtaWebChatBot: Vue.prototype.$RtaWebChatBot,
      attachmentIsActive: Vue.prototype.$config.attachmentIsActive,
      customerId: "",
      appColorCode: Vue.prototype.$color,
      oceanaURL: (window.location.protocol === "https:"?"https://":"http://") + Vue.prototype.$config.contextStoreHost,

    }
  },
  mounted() {
    this.setColorCode()
    this.setDateVariables()
  },
  beforeRouteLeave (to, from, next) {
    if (this.confirmStayInDirtyForm()){
      next(false)
    } else {
      // Navigate to next view
      next()
    }
  },
  created() {
    window.addEventListener('beforeunload', this.beforeWindowUnload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },
  methods: {
    confirmLeave() {
      return window.confirm('Leave site? Changes you made may not be saved.')
    },
    confirmStayInDirtyPage() {
      return !this.confirmLeave()
    },
    beforeWindowUnload() {
      console.log("beforeWindowUnload")
      /*if(WebChat.isCreateJourney){
        this.createJourney();
      }*/
      WebChat.sendFeedback(false);
      WebChat.sendSessionEndAndQuitChat()
      setTimeout(function(){}, 5000);
    },
    handleHistoryChange() {
      window.removeEventListener('beforeunload', this.beforeWindowUnload)

    },
    sendChatMessage() {
      if (this.file !== null) {
        this.uploadFile();
      } else {
        WebChat.sendChatMessage();
      }
      this.messageList = WebChat.messageList;
    },
    setDateVariables() {
      const today = new Date()

      const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];

      this.chatDateDay = today.getDate()
      this.chatDateYear = today.getFullYear()
      this.chatDateMonth = monthNames[today.getMonth()]
    },
    openFeedback() {
      if(!this.sessionEnd) {
        this.sessionEnd = true;
        if (WebChat.getLastCustomerMessage()) {
          WebChat.sendSessionEndAndQuitChat()
          document.getElementById("sendMessageButton").style.backgroundColor = Vue.prototype.$disableColor;
          document.getElementById("sendMessageButton").style.borderColor = Vue.prototype.$disableColor;
          $("#chatFeedback").show();
          for (const element of document.querySelectorAll(".panel-footer")) {
            element.style.zIndex = -1
          }
          WebChat.isFeedbackShow = true;
          this.findCustomer();
        } else {
          setTimeout(function(){}, 5000);
          WebChat.quitChat()
          WebChat.redirect()
        }
      }
    },
    attachContinueClose() {
      this.file = this.$refs.file.files[0];
      WebChat.attachContinueClose();
    },
    uploadFile() {
      let formData = new FormData();
      formData.append('file', this.file);
      http.post('/uploadFile', formData, {headers: {'Content-Type': 'multipart/form-data'}})
          .then(response => {
            this.fileUploadURL = response.data.fileDownloadUri;
            WebChat.sendChatMessage(this.fileUploadURL);
            this.file = null;
          }).catch(e => {
        console.log(e);
      });
    },
    adjustHeight() {
      WebChatUI.adjustHeight();
    },
    scrollUp() {
      WebChatUI.scrollUp();
    },

    restoreHeight() {
      WebChatUI.restoreHeight();
    },
    onType(event) {
      WebChat.onType(event);
    },
    setColorCode() {
      document.getElementById("sendMessageButton").style.backgroundColor = Vue.prototype.$disableColor;
      document.getElementById("sendMessageButton").style.borderColor = Vue.prototype.$disableColor;
    },
    getAgentMessage(messageTextList) {
      let agentMessageHTML = '<p dir="ltr">';
      if(this.lang == 'ar') {
        agentMessageHTML = '<p align="right" style="text-align: right">';
      }
      for(let i=0; i<messageTextList.length; i++) {
        if(messageTextList[i].type == 'text') {
          agentMessageHTML += messageTextList[i].text;
        } else if(messageTextList[i].type == 'link') {
          agentMessageHTML += '<a id="agentLink" href="' + messageTextList[i].text.replace(/\s/g, "") + '" target="_blank">' + messageTextList[i].text + '</a>';
        }
      }
      agentMessageHTML += '</p>';
      return agentMessageHTML;
    },
    setDubaiDriveURL: function() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      var appname = urlParams.get('appname');

      var customTags = document.getElementsByTagName("a");
      if (customTags && customTags.length > 0) {
        for (var i = 0; i < customTags.length; i++) {
          if(customTags[i].id == 'agentLink') {
            if (appname && appname.toLowerCase() === "dubaidrive") {
              var b = customTags[i];
              $(b).attr('target', "");

              var url = $(b).attr('href');
              var timeStamp = new Date().getTime();
              if (url.includes("&timestamp=")) {
                url = url.split("&timestamp=")[0];
              }

              if (url.charAt(0) != "#") {
                $(b).attr('href', "#" + url + "&timestamp=" + timeStamp);
              } else {
                $(b).attr('href', url + "&timestamp=" + timeStamp);
              }
            }
          }
        }
      }
    },
    findCustomer() {
      let findCustomerURL = (window.location.protocol === "https:"?"https://":"http://") + Vue.prototype.$config.contextStoreHost + "/services/CustomerManagement/rest/customers/customerId";
      http
          .get(findCustomerURL, {params:  {phone: Vue.prototype.$phone}})
          .then(response => {
            console.log('findCustomer response:', response);
            this.customerId = response.data.customerId
            WebChat.journeyCustomerId =  this.customerId;
          }).catch(error => {
        console.error('findCustomer service error!', error);
      });
    },
    createJourney: function() {
      console.log('Chat.createJourney called');
      let createJourneyURL = (window.location.protocol === "https:" ? "https://":"http://") + Vue.prototype.$config.contextStoreHost + "/services/CustomerManagement/rest/customers/journeys/element";
      let journeyObject = JSON.stringify({
        "elementId":  uuidv4() ,
        "customerId": WebChat.journeyCustomerId,
        "tenantId": "0",
        "agentId": "chatcsat",
        "type": "Survey",
        "topicName": "webcsat",
        "status": "Customer_Replied",
        "summary": "summary",
        "detail": {
          "mood": WebChat.customerFeedback.customerFeedback,
          "complaintReason": WebChat.customerFeedback.complaintReason,
          "complaintText": WebChat.customerFeedback.complaintText
        },
        "threadId": "threadId",
        "agentNote": WebChat.customerFeedback.complaintReason + ": " + WebChat.customerFeedback.complaintText,
        "source": "webcsat"
      });
      console.log('journeyObject:', journeyObject);

      const headers = {
        'Content-type': 'application/json',
        'Accept': 'application/json',
      };

      axios
          .post(createJourneyURL, journeyObject, {headers})
          .then(response => {
            console.log('createJourney response:', response);

          }).catch(error => {
        console.error('createJourney service  error!', error);
      });
    }
  }
}
</script>